import { useState } from 'react';
import { apiPatch } from '../lib/api';

// Per-contact progress marker for list views (Phase 8 item 7 — "check off which
// ones you've done"). Visually obvious colored pill; changing it PATCHes the
// contact. Optimistic so the list feels instant.
const OPTS = [
  { v: 'new', label: 'New', cls: 'border-line-strong bg-surface-3 text-muted' },
  { v: 'contacted', label: 'Contacted', cls: 'border-electric/40 bg-electric/10 text-electric' },
  { v: 'followup', label: 'Follow-up', cls: 'border-victory/40 bg-victory/10 text-victory' },
  { v: 'done', label: 'Done', cls: 'border-success/40 bg-success/10 text-success' },
];

export function WorkStatus({ contactId, value, onChange }: { contactId: number; value: string; onChange?: (v: string) => void }) {
  const [v, setV] = useState(value || 'new');
  const [busy, setBusy] = useState(false);
  const cur = OPTS.find((o) => o.v === v) || OPTS[0];

  async function set(next: string) {
    const prev = v;
    setV(next); setBusy(true); onChange?.(next);
    try { await apiPatch(`/api/contacts/${contactId}`, { workStatus: next }); }
    catch { setV(prev); onChange?.(prev); }
    finally { setBusy(false); }
  }

  return (
    <select
      value={v}
      disabled={busy}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => { e.stopPropagation(); set(e.target.value); }}
      className={`cursor-pointer rounded-md border px-2 py-0.5 text-xs font-semibold outline-none ${cur.cls}`}
      title="Your progress on this contact"
    >
      {OPTS.map((o) => <option key={o.v} value={o.v} className="bg-surface-2 text-soft">{o.label}</option>)}
    </select>
  );
}
